import i18n from '@/language/i18n'

const CUSTOM_WIDGETS_REGISTRY = Object.freeze([
    {
        moduleId: 'projectManagement',
        children: [
            {
                label: i18n.t('Common.workflow'),
                noLinkWidget: true,
                widgets: [
                    {
                        customLabel: i18n.t('Common.overview'),
                        id: 'workflow',
                        type: 'WORKFLOW',
                        sarchFilterDisabled: true,
                    },
                ]
            }
        ]
    }
]);

export default CUSTOM_WIDGETS_REGISTRY;
